module.exports = __webpack_public_path__ + "static/appdirect-logo-light-large-77bad19743a242b3c1994e0e19d6c182.png";